import { h } from 'preact'
import { Link } from 'preact-router'
import { getRoutesByLocale } from '../../core/Pages'
import useLocale from '../../hooks/useLocale'
import Container from '../Container/Container'
import * as classes from './Footer.module.css'

// TODO: similar style as header? :D
const Footer = () => {
    const locale = useLocale()
    const routes = getRoutesByLocale(locale)

    return (
        <footer className={classes.footer}>
            <Container style={{ marginTop: 0 }}>
                <div style={{ display: 'flex' }}>
                    <ul
                        className={classes.items}
                        style={{
                            display: 'flex',
                        }}
                    >
                        <li className={classes.item}>
                            <Link href={routes.CODE}>
                                🍵{' '}
                                <span
                                    style={{
                                        display: true
                                            ? 'inline-block'
                                            : 'none',
                                    }}
                                    className={classes.code}
                                >
                                    {' '}
                                    code of
                                </span>{' '}
                                ethics
                            </Link>{' '}
                        </li>

                        {!true && (
                            <li className={classes.item}>
                                <Link href="https://www.instagram.com/daanno_o/">
                                    🧙🏻‍♂️ social
                                </Link>{' '}
                            </li>
                        )}

                        <li  className={classes.item}>
                            <Link href={routes.LEGAL}>⚖️ legal</Link>{' '}
                        </li>
                    </ul>
                </div>
            </Container>
        </footer>
    )
}

export default Footer
